<template>
    <div class="container">
        <b-modal :model-value="modalEditaEcp" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.editEcp }} 
            </div>
            <div v-if="dataDetallEcp && dataDetallEcp.length > 0">
                <b-row class="">
                    <b-col cols="0"></b-col>
                    <b-col cols="3" class="text-left">
                        <h5>{{labels.contable}}</h5> 
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <h6>{{ dataDetallEcp[0]?.contable == 1 ? 'SI' : 'NO' }}</h6>
                    </b-col>
                </b-row>
                <b-row class="" v-if="dataDetallEcp[0]?.contable == 1 ? true : showCuenta">
                    <b-col cols="0"></b-col>
                    <b-col cols="3" class="text-left">
                        <h5>{{labels.account}}</h5> 
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <h6>{{ dataDetallEcp[0]?.cuenta || '-' }}</h6>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="0"></b-col>
                    <b-col cols="3" class="text-left">
                        <h5>{{labels.actual}}</h5> 
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <select v-model="dataDetallEcp[0].actual" id="" class="form-control"> 
                            <option value="1"> {{ labels.yes }} </option> 
                            <option value="0"> {{ labels.not }} </option> 
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="0"></b-col>
                    <b-col cols="3" class="text-left">
                        <h5>{{labels.operacion}}</h5> 
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <select v-model="dataDetallEcp[0].operacion" id="" class="form-control"> 
                            <option value="+"> {{ labels.sumar }} </option> 
                            <option value="-"> {{ labels.restar }} </option> 
                        </select>
                    </b-col>
                </b-row>
                <b-row class="" v-if="dataDetallEcp[0]?.contable == 0 ? true : showFormulacion">
                    <b-col cols="0"></b-col>
                    <b-col cols="2" class="text-left">
                        <h5>{{labels.formulacion}}</h5> 
                    </b-col>
                    <b-col cols="10" lg="10" class="text-right">
                        <input v-if="administrador" type="radio" value="m" id="" v-model="chk" class="ml-3"> <span v-if="administrador" >Valor Manual</span>
                        <input v-if="administrador" type="radio" value="cons" id="" v-model="chk" class="ml-3"> <span v-if="administrador" >Ajuste Consol</span>
                        <input type="radio" value="sf" id="" v-model="chk" class="ml-3"> <span>Fila</span>
                        <input type="radio" value="sc" id="" v-model="chk" class="ml-3"> <span>Columna</span>
                        <input type="radio" value="c" id="" v-model="chk" class="ml-3"> <span>Celda</span>
                        <input type="radio" value="n" id="" v-model="chk" class="ml-3"> <span>Niif</span>
                    </b-col>
                </b-row>
                <b-row class="" v-if="showSumaFila">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>Suma Fila:</h5>
                    </b-col>
                    <b-col cols="1" lg="6" class="text-left">
                        <input v-model="dataDetallEcp[0].formulacion" type="text"> 
                    </b-col>
                </b-row>
                <b-row class="" v-if="showSumaColumna">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>Suma Columna:</h5>
                    </b-col>
                    <b-col cols="1" lg="6" class="text-left">
                        <input v-model="dataDetallEcp[0].formulacion" type="text"> 
                    </b-col>
                </b-row>
                <b-row class="" v-if="showCelda">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>Celda:</h5>
                    </b-col>
                    <b-col cols="1" lg="2" class="text-left">
                        <input v-model="regFila" type="number">
                    </b-col>
                    <b-col cols="1" lg="2" class="text-left">
                        <input v-model="regCol" type="number">
                    </b-col>
                </b-row>
                <b-row class="" v-if="showNiif">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>Niif:</h5>
                    </b-col>
                    <b-col cols="6" lg="6" class="text-left">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <select multiple v-model="arrNiif" class="form-control">
                                    <option v-for="niif in listNiif" :value="niif?.niif" :key="niif.id">{{niif?.niif}}-{{ niif?.nameNiif }}</option>
                                </select>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="editaCuenta" :disabled="readOnly">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="clicked">{{ labels.close }}</b-button> 
                </div>
            </div>
            <div v-else class="text-center py-4">
                <p>{{ labels.noData }}</p>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import PlanConsolidacion from '../../services/PlanConsolidacion'; 
import EcpReporte from '../../services/EcpReporte'; 

export default {
    name: "EditaCuentaEcp",
    props: {
        modalEditaEcp: {
            type: Boolean,
            default: false
        },
        dataDetallEcp: {
            type: Array,
            default: () => []
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        administrador: false,
        showCuenta: false,
        showFormulacion: false,
        chk: '',
        showNiif: false,
        showSumaFila: false,
        showSumaColumna: false,
        showCelda: false,
        regFila: "",
        regCol: "",
        listNiif: [],
        arrNiif: [],
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    editEcp: "Edita detalle ECP",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    yes: "SI",
                    not: "NO",
                    account: "Cuenta:",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulación:",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    noData: "No hay datos para editar"
                }  
            } else {
                return {
                    editEcp: "Edit ECP detail",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    yes: "YES",
                    not: "NO",
                    account: "Account:",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulation:",
                    vigencia: "Validity:",
                    company: "Company:",
                    noData: "No data to edit"
                }                
            }
        }
    },
    methods: {
        async editaCuenta() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para editar.')
                return
            }
            
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) {
                this.$toast.error('No hay datos para editar')
                return
            }

            if (this.chk == 'n') {
                if (this.arrNiif.length == 0) {
                    this.$toast.error("Niif sin seleccionar")
                    return
                }
            }

            this.dataDetallEcp[0].chkSel = this.chk
            
            if (this.chk == 'm') {
                this.dataDetallEcp[0].formulacion = "MANUAL"
            } else if (this.chk == 'n') {
                this.dataDetallEcp[0].formulacion = this.arrNiif
            } else if (this.chk == 'sf') {
                // Mantener el valor actual
            } else if (this.chk == 'sc') {
                // Mantener el valor actual
            } else if (this.chk == 'c') {
                this.dataDetallEcp[0].formulacion = 'CELDA(' + this.regFila + ',' + this.regCol + ')'
            }

            this.dataDetallEcp[0].idUser = this.$store.state.userId
            
            try {
                let updatDetEcp = await EcpReporte.updateDetCuentaEcp(this.dataDetallEcp[0])
                if (updatDetEcp.status == 200) { 
                    this.$toast.success(updatDetEcp.data.message)
                    setTimeout(() => {                        
                        this.reloadTable()
                    }, 1500)
                } else {
                    this.$toast.error(updatDetEcp.data.message)
                }
            } catch (err) {
                console.error(err)
                this.$toast.error('Error al actualizar la cuenta')
            }
        },

        clicked() {
            this.$emit('cierraMod', false)
        },

        asignaCelda(celda) {
            if (!celda) return
            
            let filaCel = celda.indexOf('(') 
            let fila = celda.slice(filaCel + 1, 8) 
            this.regFila = fila
            
            let columnaCel = celda.indexOf(',') 
            let columna = celda.slice(columnaCel + 1, 11) 
            this.regCol = columna
        },

        reloadTable() {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) return
            
            let info = {
                'vigencia': this.dataDetallEcp[0].vigencia,
                'companyId': this.dataDetallEcp[0].id_compania,
                'codReporte': this.dataDetallEcp[0].codReporte,
                'fila': this.dataDetallEcp[0].fila,
                'columna': this.dataDetallEcp[0].columna
            }
            this.$emit('reloadTable', info)
        },

        resetFormulacionData() {
            this.showNiif = false
            this.showSumaFila = false
            this.showSumaColumna = false
            this.showCelda = false
            this.arrNiif = []
        },

        cargarNiif() {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) return
            
            PlanConsolidacion.getPlanConsPorCompVige(
                this.dataDetallEcp[0].vigencia, 
                this.dataDetallEcp[0].codReporte
            )
            .then((res) => { 
                this.listNiif = res.data.planConsNiif || []
            })
            .catch((err) => { 
                console.error(err)
                this.listNiif = []
            })
        }
    },
    mounted() {
        if (this.$route.name == "ecpReporteADM") {
            this.administrador = true
        }
    },
    watch: {
        dataDetallEcp: {
            immediate: true,
            handler(valNew) {
                if (!valNew || valNew.length === 0) return
                
                const item = valNew[0]
                if (!item) return

                const formulacion = item.formulacion || ''
                const contable = item.contable

                // Resetear estados
                this.resetFormulacionData()

                if (formulacion.slice(0, 1) == "M") { 
                    this.chk = 'm'
                } else if (formulacion.slice(0, 1) == "") { 
                    this.chk = ''
                } else if (formulacion.slice(0, 1) == "N" && contable == 0) { 
                    this.chk = 'n'
                    this.showNiif = true
                    this.cargarNiif()
                } else if (formulacion.slice(0, 5) == "SUMAF" && contable == 0) { 
                    this.chk = 'sf'
                    this.showSumaFila = true
                } else if (formulacion.slice(0, 5) == "SUMAC" && contable == 0) { 
                    this.chk = 'sc'
                    this.showSumaColumna = true
                } else if (formulacion.slice(0, 2) == "CE" && contable == 0) { 
                    this.chk = 'c'
                    this.showCelda = true
                    this.asignaCelda(formulacion)
                } else if (formulacion.slice(0, 2) == "CM" && contable == 0) { 
                    this.chk = 'cons'
                }
            }
        },

        chk(valNew) {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) return

            this.resetFormulacionData()

            if (valNew == "m") {
                this.dataDetallEcp[0].formulacion = ""
                this.dataDetallEcp[0].chkSel = valNew
            } else if (valNew == "cons") {
                this.dataDetallEcp[0].formulacion = ""
                this.dataDetallEcp[0].chkSel = valNew
            } else if (valNew == "n") {
                this.dataDetallEcp[0].formulacion = ""
                this.showNiif = true
                this.dataDetallEcp[0].chkSel = valNew
                this.cargarNiif()
            } else if (valNew == "sf") {
                this.showSumaFila = true
                this.dataDetallEcp[0].chkSel = valNew
                this.dataDetallEcp[0].formulacion = ""
            } else if (valNew == "sc") {
                this.showSumaColumna = true
                this.dataDetallEcp[0].chkSel = valNew
                this.dataDetallEcp[0].formulacion = ""
            } else if (valNew == "c") {                
                this.showCelda = true
                this.dataDetallEcp[0].chkSel = valNew
                if (this.dataDetallEcp[0].formulacion) {
                    this.asignaCelda(this.dataDetallEcp[0].formulacion)
                }
                this.dataDetallEcp[0].formulacion = ""
            }
        },

        modalEditaEcp(valNew) {
            // Cuando se abre el modal, si hay datos, procesarlos
            if (valNew && this.dataDetallEcp && this.dataDetallEcp.length > 0) {
                // Forzar el watch de dataDetallEcp
                this.$watch('dataDetallEcp', () => {}, { immediate: true })
            }
        }
    }
}
</script>

<style src="../main.css"></style>